import { faFilter } from '@fortawesome/pro-regular-svg-icons/faFilter';
import { faFilter as filterSolid } from '@fortawesome/pro-solid-svg-icons/faFilter';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export const PosTableFilterIcon = (filtered: boolean) => (
  <FontAwesomeIcon icon={filtered ? filterSolid : faFilter} />
);
